import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from '@nrwl/environment';

@Injectable({
  providedIn: 'root',
})
export class FormPdfService {
  constructor(private httpClient: HttpClient) {}

  getById(templateId: number) {
    const headerOptions = new HttpHeaders({
      'Content-Type': 'application/pdf',
      Accept: 'application/pdf',
    });

    const requestOptions = {
      headers: headerOptions,
      responseType: 'blob' as 'json',
    };

    return this.httpClient.get(
      environment.baseAPIUrlv3 + 'formtemplate/' + templateId + '/download/',
      requestOptions,
    );
  }
}
